import { EMPLOYEE_BASE_URL } from "src/redux/api/appConst";
import { axiosAuth } from "src/redux/api/common";
import { Filters } from "../hooks/useGoals";

export const getGoalParams = async (filters: Filters) => {
  const api = axiosAuth(EMPLOYEE_BASE_URL);

  const { month, year, employeeId } = filters;

  const params = new URLSearchParams();

  if (month?.trim()) params.set("month", month.trim());
  if (year?.trim()) params.set("year", year.trim());

  const { data } = await api.get(
    `/goal-sheet/${employeeId}?${params.toString()}`,
  );

  console.log(data.data.goal_sheets[0]);

  return data.data.goal_sheets[0];
};
